import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserInfo } from '../stores/authentication.store';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
    constructor(private translate: TranslateService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler,): Observable<HttpEvent<any>> {
        // Intercept the request here
        // Modify headers, handle errors, etc.

        // Forward the modified request to the next interceptor or to the backend
        const defaultLanguage = this.translate.defaultLang;
        const modifiedRequest = request.clone({
            setHeaders: {
                'language': defaultLanguage ? defaultLanguage : 'pg'
            }
        });
        return next.handle(modifiedRequest);
    }
}